import { useDispatch } from "react-redux";

import { getUnixTime } from "date-fns";

import SetAdvisor from "data/advisor/actions";
import useCurrentUser from "data/advisor/useCurrentUser";
import { SetAdvisorPreferences } from "data/libs/advisor";

function useShouldSnoozeReminder() {
  const user = useCurrentUser();
  const dispatch = useDispatch();

  return {
    isSnoozed: (campaign) => {
      return user.snooze?.[campaign];
    },
    snooze: async (campaign, days) => {
      try {
        await SetAdvisorPreferences(user.id, {
          key: `snooze_${campaign}`,
          value: { lastDismissal: getUnixTime(new Date()), days: days },
        });

        dispatch(
          SetAdvisor({
            ...user,
            snooze: { ...(user.snooze || {}), [campaign]: true },
          })
        );
      } catch (error) {
        console.error("Failed to set snooze preferences:", error);
      }
    },
  };
}

export default useShouldSnoozeReminder;
